var map = {
	"./coverage.svg": "3d3b",
	"./currency.svg": "fab9",
	"./customers.svg": "0cfb2",
	"./ebitda.svg": "5070",
	"./flag.svg": "147a",
	"./market-share.svg": "025d",
	"./ownership.svg": "ab66",
	"./paneration.svg": "747f",
	"./revenue.svg": "e74b",
	"./towers.svg": "6901",
	"./wifi.svg": "5289"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2175";